import * as _ from 'lodash';
import contract from '../../../services/contracts'
import sales from '../../../services/sales'
import Payment from '../../common/adhesion/payment';
import * as utils from '../../../utils.js'


export default {
  props: ['contractId','payment', 'planId', 'addressMailing', 'creditCardOptions', 'bankAccountOptions', 'bankBillOption', 'value', 'showNewPayment'],
  data() {
    return {
      arrayDebito: undefined,
      arrayCartao: undefined,
      boletoCadastrato: undefined,
      boleto: undefined,
      index: 1,
      contractPaymentMethodId: this.value,
      loading:undefined,
      paymentSelected: this.payment,
      typesAlowed: {},

    }
  },
  mounted: function () {
    this.typesAlowed = this.$store.getters.getPaymentsTypesByPlan(this.planId);

    // pega as formas de pagamentos ja cadastradas, e exibe apenas as aceitas no plano a ser aderido
    this.loading = contract.getPaymentMethod().then(result => {
      let data = result;
      this.arrayCartao = this.typesAlowed.creditCard ? _.filter(data, {type: 'CC'}) : undefined;
      this.arrayDebito = this.typesAlowed.bankAccount ? _.filter(data, {type: 'DC'}) : undefined;
      this.removeDuplicity();
    });

    this.$store.commit('currentPlanId', this.planId);

  },
  watch:{
    contractPaymentMethodId(newValue){
      this.$emit('input', newValue);
    }
  },
  methods: {
     
    imageUrl(paymentMethod){
      if(!paymentMethod)
        return "";
      return '/static/payment-methods/' + paymentMethod.imagePath.split('.')[0] + '.svg';
    },
    removeDuplicity(){

      let map = new Map();
      if(this.arrayCartao){
        map.clear();
        this.arrayCartao.forEach((element,index) => {
          let key  = `${element.creditCard.brand}${element.creditCard.ownerName}${element.creditCard.expirationYear}${element.creditCard.expirationMonth}`;
          if(!map.has(key)){
            map.set(key,element);
          }
        });
        this.arrayCartao = Array.from(map,(value)=>value[1]);
      }

      if(this.arrayDebito){
        map.clear();
        this.arrayDebito.forEach((element,index) => {
          let key  = `${element.bankAccount.accountDigit}${element.bankAccount.accountNumber}${element.bankAccount.agencyNumber}`;
          if(!map.has(key)){
            map.set(key,element);
          }
        });
        this.arrayDebito = Array.from(map,(value)=>value[1]);
      }

    },
    validateAll(){
      if(!this.contractPaymentMethodId){

        return Promise.reject({customMsg: "Por favor selecione uma forma de pagamento"});

      } else if(this.contractPaymentMethodId == 'newBankBill'){
        delete this.payment.bankAccount;
        delete this.payment.creditCard;
        this.payment.bankBill = this.bankBillOption;
        this.payment.paymentMethodId = this.bankBillOption.bankBill.paymentMethodId;
        this.payment.imagePath = this.bankBillOption.bankBill.imagePath;
        this.$emit('paymentSelected', this.bankBillOption);
        return Promise.resolve(true);

      } else if(this.contractPaymentMethodId == 'newPayment'){

        this.$emit('paymentSelected', this.payment);
        return this.$refs.payment.validateAll();

      } else {
        
        if(this.paymentSelected.creditCard){
            if (!utils.validateCreditCard(this.paymentSelected.creditCard.expirationMonth, this.paymentSelected.creditCard.expirationYear)) {
              return Promise.reject({customMsg: `Data de validade do cartão expirou: ${this.paymentSelected.creditCard.expirationMonth}/${this.paymentSelected.creditCard.expirationYear}. Cadastre uma nova forma de pagamento, válida!` });
          }
        }
        if(this.paymentSelected.creditCard){
          if(!this.paymentSelected.secureCodeCreditCard || this.paymentSelected.secureCodeCreditCard.length < 3 )
            return Promise.reject({customMsg: "Informe o código de segurança do cartão"});
        }
        this.$emit('paymentSelected', this.paymentSelected);
        return Promise.resolve(true);
      }

    },
    getPaymentSelected(){
      if(this.contractPaymentMethodId == 'newBankBill' || this.contractPaymentMethodId == 'newPayment'){
        return this.payment;
      } else {
        return this.paymentSelected;
      }
    }

  },
  computed: {

  },
  components:{
    Payment
  },
}



// WEBPACK FOOTER //
// ./src/pages/account/contract/choose-payment-new-contract.js